var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.messages),function(message,index){return _c('MessageSnack',{key:index,staticClass:"top-modifier",attrs:{"message":message,"message-index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }